module.exports = __webpack_public_path__ + "img/fineness-2@2x.be52f3e.png";